module.exports = __webpack_public_path__ + "static/media/interactive-audio.c8dd5b61.svg";